import React from "react";
import PropTypes from 'prop-types'
import ButtonSquare from "../../components/Button/ButtonSquare";
import PdfIcon from "../../common/images-new/pdf-icon.svg"
import LinkIcon from "../../common/images-new/link-icon.svg"
import EditPhotoIcon from "../../common/images-new/edit-photo-icon.svg"
import { Card, TextGray } from "../../pages/Theme";
import { MdOutlineFileUpload, MdOutlineLink } from 'react-icons/md'
import NoProfilePhoto from "../../common/images-new/no-profile-pic.png";

const EditCardProfile = ({profilePhoto, username, email}) => {
    return(
        <Card className="flex flex-col w-72 px-4 -mt-32 md:-my-36 lg:-my-48 xl:-mt-64 mb-1 lg:mb-5 items-center rounded-xl z-0">
            <div className="py-10 flex flex-col justify-center max-w-full overflow-hidden">
                <div className="relative pb-3 flex justify-center p-2">
                    <img className="rounded-full w-36 h-36" src={profilePhoto ? profilePhoto : NoProfilePhoto} alt="Profile pic"></img>
                    {/* <img className="inline-block rounded-full absolute right-14 bottom-2 cursor-pointer" src={EditPhotoIcon} alt="edit profile"></img> */}
                </div>
                
                <p className="text-xl font-bold pb-2 text-center break-words">{username}</p>
                <TextGray className="text-base text-gray-400 font-normal text-center break-words">{email}</TextGray>
                
            </div>
            
            <div className="pb-3">
                <div className="w-24 bg-gray-200 h-4 rounded-md"></div>
                <div className="mt-2 w-44 bg-gray-200 h-4 rounded-md"></div>

                <div className="my-5 pb-4 flex flex-row">
                    <div className="mt-2 w-24 bg-gray-200 h-4 rounded-md"></div>
                </div>
                <div className="mt-2 w-full bg-gray-200 h-4 rounded-md"></div>
                <div className="mt-2 w-full bg-gray-200 h-4 rounded-md"></div>
                <div className="mt-2 w-full bg-gray-200 h-4 rounded-md"></div>
                <div className="mt-2 mb-8 w-3/6 bg-gray-200 h-4 rounded-md"></div>
                <div className="flex flex-row space-x-12 mb-5 items-center justify-center">
                    <ButtonSquare height="20">
                        <MdOutlineLink className="w-10 h-10"/>
                     </ButtonSquare>   
                    <ButtonSquare height="20">
                        <MdOutlineFileUpload className="w-10 h-10"/>
                    </ButtonSquare>
                </div>
                
                
            </div>
        </Card>
    )
}

EditCardProfile.propTypes = {
    profilePic: PropTypes.string,
    username: PropTypes.string,
    email: PropTypes.string,
    program: PropTypes.string, 
    aboutMe: PropTypes.string,
}
export default EditCardProfile